module.exports = __webpack_public_path__ + "static/media/react.e88c96f0.png";